export default __webpack_public_path__ + "static/media/bg-contacto.d75efc6f.jpg";